import React from 'react';

import { Column } from "components/Layout/Grid";
import Text from "components/Text";

import { ProcessDetailsProps } from "./interface";
import { currencyOutputNumber } from 'utils/CurrencyOutput';

export const TicketDetails: React.FC<ProcessDetailsProps> = ({ ticket }) => (
  <Column className="mt-5 grid-gap-1">
    <Text className="color-blue-gray" weight="bold" size={16}>
      Protocolo: <strong>{ticket?.protocolNumber}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      Cliente: <strong>{ticket?.customerName}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      CNPJ: <strong>{ticket?.cnpj}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      Pedido: <strong>{ticket?.order?.protheusOrderSale}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      Nota Fiscal: <strong>{`${ticket?.order?.invoiceNumber || ''}/${ticket?.order?.invoiceSerialNumber || ''}`}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      Transportadora: <strong>{ticket?.order?.shippingCompanyName}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      Filial: <strong>{ticket?.order?.subsidiaryName}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      Motivo: <strong>{ticket?.ticketReason}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      Solicitante: <strong>{ticket?.requesterDescription}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      Tipo de solução: <strong>{ticket?.solutionType}</strong>
    </Text>
    <Text className="color-blue-gray" weight="bold" size={16}>
      Valor da Reclamação: <strong>{currencyOutputNumber(ticket?.reclamationPrice || 0)}</strong>
    </Text>
  </Column>
);